const data = [
  {
    id: 1,
    name: 'Aaron Ramsdale',
    rating: 9,
    reason: 'One outstanding save to keep out Mo Salah in the second half. Was fortunate with the penalty but earned hisluck with some smart keeping. Superb save late on to keep Nunez also, but the final stops from Salah and Konate were the best.',
  },
  {
    id: 2,
    name: 'Ben White',
    rating: 5,
    reason: ' Not a good day at the office for the England defender. Poor in possession consistently and not great in his one-vs-one duels. Allowed Liverpool chances to advance down the left too often.',
  },
  {
    id: 3,
    name: 'Rob Holding',
    rating: 7,
    reason: 'Did give away the penalty but it was more bad luck than bad judgement. Solid aside from that against a very difficult opponent.',
  },
];

export default data;
